module.exports = __webpack_public_path__ + "img/2.1a92f4a1.png";